import BaseTasksEvAHTMLPreviewStrategy from './BaseTasksEvAHTMLPreviewStrategy'

export default function EstimatedTasksEvAHTMLPreviewStrategy() {}

EstimatedTasksEvAHTMLPreviewStrategy.prototype = new BaseTasksEvAHTMLPreviewStrategy();

EstimatedTasksEvAHTMLPreviewStrategy.prototype.init = function ( timeFormat ) {
    BaseTasksEvAHTMLPreviewStrategy.prototype.init.call( this, timeFormat );
    return this;
};

EstimatedTasksEvAHTMLPreviewStrategy.prototype.getTableClass = function () {
    return "";
};

EstimatedTasksEvAHTMLPreviewStrategy.prototype.getColumnsNumber = function () {
    return 3;
};

EstimatedTasksEvAHTMLPreviewStrategy.prototype.addFirstHeaderRowCells = function ( row ) {
    this.addCell( row, this.message( "report.budgeted_vs_actual.spent_time" ), "spentTime", 1, 3 );
    this.addCell( row, this.message( "report.budgeted_vs_actual.estimated_time" ), "estimatedTime", 1, 3 );
    this.addCell( row, this.message( "report.budgeted_vs_actual.variance.description" ), "varianceDescr", 2, 1 );
};

EstimatedTasksEvAHTMLPreviewStrategy.prototype.addSecondHeaderRowCells = function ( row ) {
    this.addCell( row, this.message( "report.budgeted_vs_actual.variance.mh" ), "varianceMh", 1, 2 );
    this.addCell( row, this.message( "report.budgeted_vs_actual.variance.percent" ), "variancePercent", 1, 2 );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/eva/EstimatedTasksEvAHTMLPreviewStrategy.js